import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import PrestigeBonusSkillNode from "./PrestigeBonusSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";

export default class PrestigeBonusSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     */
    constructor(totals, values, mineDamageLogic) {
        super(SkillIds.PRESTIGE_BONUS);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 10;
        let cost = 10;
        let purchaseIndex = 0;

        const prestigeBonus1 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus1', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus2 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus2', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus3 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus3', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus4 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus4', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus5 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus5', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus6 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus6', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus7 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus7', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus8 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus8', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus9 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus9', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus10 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus10', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus11 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus11', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus12 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus12', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus13 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus13', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus14 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus14', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus15 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus15', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus16 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus16', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus17 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus17', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus18 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus18', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus19 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus19', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus20 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus20', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const prestigeBonus21 = this.addNode(new PrestigeBonusSkillNode('prestigeBonus21', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));
        


        prestigeBonus1.addChildNode(prestigeBonus2);
        prestigeBonus2.addChildNode(prestigeBonus3);
        prestigeBonus3.addChildNode(prestigeBonus4);
        prestigeBonus4.addChildNode(prestigeBonus5);
        prestigeBonus5.addChildNode(prestigeBonus6);
        prestigeBonus6.addChildNode(prestigeBonus7);
        prestigeBonus7.addChildNode(prestigeBonus8);

        prestigeBonus8.addChildNode(prestigeBonus9);
        prestigeBonus9.addChildNode(prestigeBonus10);
        prestigeBonus10.addChildNode(prestigeBonus11);
        prestigeBonus11.addChildNode(prestigeBonus12);
        prestigeBonus12.addChildNode(prestigeBonus13);
        prestigeBonus13.addChildNode(prestigeBonus14);
        prestigeBonus14.addChildNode(prestigeBonus15);

        prestigeBonus15.addChildNode(prestigeBonus16);
        prestigeBonus16.addChildNode(prestigeBonus17);
        prestigeBonus17.addChildNode(prestigeBonus18);
        prestigeBonus18.addChildNode(prestigeBonus19);
        prestigeBonus19.addChildNode(prestigeBonus20);
        prestigeBonus20.addChildNode(prestigeBonus21);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = -1;
        const startY = -3;

        prestigeBonus1.setPosition(startX, startY);
        prestigeBonus2.setPosition(startX - 1, startY);
        prestigeBonus3.setPosition(startX - 2, startY);
        prestigeBonus4.setPosition(startX - 3, startY);
        prestigeBonus5.setPosition(startX - 4, startY);
        prestigeBonus6.setPosition(startX - 5, startY);
        prestigeBonus7.setPosition(startX - 6, startY);

        prestigeBonus8.setPosition(startX - 6, startY - 1);
        prestigeBonus9.setPosition(startX - 5, startY - 1);
        prestigeBonus10.setPosition(startX - 4, startY - 1);
        prestigeBonus11.setPosition(startX - 3, startY - 1);
        prestigeBonus12.setPosition(startX - 2, startY - 1);
        prestigeBonus13.setPosition(startX - 1, startY - 1);
        prestigeBonus14.setPosition(startX, startY - 1);

        prestigeBonus15.setPosition(startX, startY - 2);
        prestigeBonus16.setPosition(startX - 1, startY - 2);
        prestigeBonus17.setPosition(startX - 2, startY - 2);
        prestigeBonus18.setPosition(startX - 3, startY - 2);
        prestigeBonus19.setPosition(startX - 4, startY - 2);
        prestigeBonus20.setPosition(startX - 5, startY - 2);
        prestigeBonus21.setPosition(startX - 6, startY - 2);

    }
    
}